import numeral from 'numeral'
import { kuiperClassNames, Icon } from '@opallabs/kuiper'
import { DateRange } from '@opallabs/lapidary'
import './styles.scss'

export const formatBudget = (budget: number) => {
  if (budget < 1000) {
    return `$${Math.round(budget)}`
  }
  const convertedBudget = numeral(budget).format('($0.0a)')
  return convertedBudget.replace(/(\.0)/, '')
}

type StoryGanttPopoverTextProps = {
  budget?: string
  description?: string
  endDate: Date
  shouldShowBudget?: boolean
  startDate: Date
  title?: string
}

export const StoryGanttPopoverText = ({
  budget,
  description,
  endDate,
  shouldShowBudget = false,
  startDate,
  title,
}: StoryGanttPopoverTextProps) => (
  <div className={kuiperClassNames('story-popover-text')}>
    <div>
      <span>{title}</span>
      {shouldShowBudget && typeof budget === 'string' && (
        <span className={kuiperClassNames('story-popover-budget')}>
          {formatBudget(parseInt(budget, 10))}

          <Icon ariaMode="hidden" glyph="budget-m" height={12} width={12} />
        </span>
      )}
    </div>
    <DateRange endDate={endDate} startDate={startDate} />
    <p>{description}</p>
  </div>
)
